import React, { createContext, useContext, useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
  });

  const showNotification = (message) => {
    setNotification({ open: true, message });
    setTimeout(() => setNotification({ open: false, message: "" }), 4000); // auto-hide after 4 seconds
  };

  useEffect(() => {
    const handleErrorEvent = (event) => {
      showNotification(event.detail);
    };

    // Listen for the custom 'api-error' event
    window.addEventListener("api-error", handleErrorEvent);

    // Cleanup
    return () => {
      window.removeEventListener("api-error", handleErrorEvent);
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {/* Assuming you're using Material-UI for the Snackbar */}
      {notification.open && (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={notification.open}
          autoHideDuration={5000}
        >
          <Alert severity={"error"}>{notification.message}</Alert>
        </Snackbar>
      )}
    </NotificationContext.Provider>
  );
};
